<template>
  <div>
    <div class="main">
      <div class="mainBox">
        <h1 class="logo"></h1>
        <p class="welcome">{{ $t('loginPage.title') }}</p>
        <button @click="login('FB')" class="FBbtn btn_w" style="bottom: 239px;">{{ $t('loginPage.fbBtn') }}</button>
        <button @click="login('GOOGLE')" class="Googlebtn btn_w" style="bottom: 180px;">{{ $t('loginPage.googleBtn') }}</button>
        <button id="smsLoginBtn" class="SMSbtn btn_w">{{ $t('loginPage.phoneBtn') }}</button>
        <p class="subText">{{ $t('loginPage.loginTip') }}</p>
      </div>
    </div>

    <div v-if="isSMSInputModalShow" class="modal">
      <div class="modal-content">
        <span class="close" @click="isSMSInputModalShow = false">&times;</span>
        <div class="form-box" v-if="!confirmationResultOfSMS">
          <label for="telNo">Phone number:</label>
          <input id="telNo" type="number" v-model="phoneNumber" placeholder="ex: 0912345678">
          <button class="button" @click="sendSMS">{{ $t('loginPage.submit') }}</button>
        </div>
        <div class="form-box" v-else>
          <label for="telNo">SMS code:</label>
          <input id="telNo" type="number" v-model="smsCode" :placeholder="$t('loginPage.textCodeInput')">
          <button class="button" @click="loginWithSMS">{{ $t('loginPage.submit') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase/app'
import { mapMutations, mapActions } from 'vuex'
import { detect } from 'detect-browser'
import auth from '../authConfig'

export default {
  name: 'Login',
  data() {
    return {
      userInfo: null,
      isCookieAlertOpen: true,
      isSMSInputModalShow: false,
      phoneNumber: null,
      confirmationResultOfSMS: null,
      smsCode: '',
    }
  },
  mounted() {
    this.checkInApp()
    this.setRecaptcha()
    this.askGPS()
  },
  methods: {
    ...mapMutations([
      'updateUserInfo',
    ]),
    ...mapActions([
      'trackerLog',
    ]),
    login(type) {
      let provider = null
      if (type === 'FB') {
        provider = new firebase.auth.FacebookAuthProvider()
      } else if (type === 'GOOGLE') {
        provider = new firebase.auth.GoogleAuthProvider()
      }
      if (provider) {
        auth
          .signInWithPopup(provider)
          .then((result) => {
            this.userLogin(result.user)
          })
          .catch((err) => {
            console.error(err)
            this.$alert.wraningAlert(this.$t('loginPage.loginFailed'))
          })
      }
    },
    loginWithSMS() {
      this.confirmationResultOfSMS.confirm(this.smsCode).then((result) => {
        this.userLogin(result.user)
      }).catch((error) => {
        console.error(error)
        this.$alert.wraningAlert(this.$t('loginPage.SMSValidFailed'))
      })
      this.isSMSInputModalShow = false
    },
    sendSMS() {
      const appVerifier = window.recaptchaVerifier
      const phoneNumber = `+886${this.phoneNumber.slice(1, 10)}`
      firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
        .then((confirmationResult) => {
          this.confirmationResultOfSMS = confirmationResult
        }).catch((error) => {
          this.$alert.wraningAlert(this.$t('loginPage.sendSMSFailed'))
          console.error(error)
        })
    },
    setRecaptcha() {
      // Start Firebase invisible reCAPTCHA verifier
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('smsLoginBtn', {
        size: 'invisible',
        callback: (res) => {
          if (res) console.debug(res)
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          this.isSMSInputModalShow = true
        },
      })
      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId
      })
    },
    userLogin(userInfo) {
      const {
        displayName, email, phoneNumber, photoURL, uid,
      } = userInfo
      const data = {
        displayName,
        email,
        phoneNumber,
        photoUrl: photoURL,
        projectCode: 'f5e57560-8534-442e-b7e3-cd20c545a4de',
        qrcode: 'followAppWebGen-test-qrcode',
        uid,
      }
      this.$LoginAPI.login(data).then((res) => {
        data.uid = res.data.USERID
        data.name = res.data.USERNAME
        this.updateUserInfo(data)

        // log login
        this.trackerLog({
          event: 'login',
          message: {
            userId: data.uid,
            userName: data.name,
          },
        })

        if (res.data.ISMEMBER === 'Y') {
          this.$router.push({ name: 'Start' })
        } else {
          this.$router.push({ name: 'Register' })
        }
      }).catch((err) => {
        this.$alert.wraningAlert(err)
        console.error(err)
      })
    },
    goto(name) {
      this.$router.push({ name })
    },
    askGPS() {
      if ('geolocation' in navigator) {
        /* geolocation is available */
        navigator.geolocation.getCurrentPosition((position) => {
          this.recordeCoords(position.coords.latitude, position.coords.longitude)
        }, this.handleGPSError)
      } else {
        this.$alert.wraningAlert(this.$t('loginPage.GPSBrowserFailed'))
      }
    },
    checkInApp() {
      const browser = detect()
      const whiteList = ['chrome', 'crios']
      if (!whiteList.includes(browser.name)) {
        this.$alert.wraningAlert(this.$t('loginPage.borwserFailed'))
      }
    },
    recordeCoords(latitude, longitude) {
      this.trackerLog({
        event: 'get_first_geo',
        message: {
          latitude,
          longitude,
        },
      })
    },
    handleGPSError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.$alert.wraningAlert(this.$t('loginPage.GPS_ERROR_PERMISSION_DENIED'))
          break
        case error.POSITION_UNAVAILABLE:
          this.$alert.wraningAlert(this.$t('loginPage.GPS_ERROR_POSITION_UNAVAILABLE'))
          break
        case error.TIMEOUT:
          this.$alert.wraningAlert(this.$t('loginPage.GPS_ERROR_TIMEOUT'))
          break
        case error.UNKNOWN_ERROR:
          this.$alert.wraningAlert(this.$t('loginPage.GPS_ERROR_UNKNOWN_ERROR'))
          break
        default:
          this.$alert.wraningAlert(this.$t('loginPage.GPS_ERROR_ORTHER'))
      }
    },
  },
}
</script>
